import { gql } from "apollo-angular";

const DF =  gql`
fragment DF on Divider {
    backgroundColor {
      color
    }
    showAccent
}`


export {DF}